module.exports = __webpack_public_path__ + "static/media/socialPiper-schedule-desktop-en.9754d205.png";